import { createAction, props } from '@ngrx/store';
import {LocationSet} from '@emm/core/models/location-set.model';

export enum MmsAdminAction {
    LoadAllLocation = '[MMS Admin Override] Load All Location',
    LoadAllLocationSuccess = '[Management API] Load All Location Success',
    LoadAllLocationFailure = '[Management API] Load All Location Failure',
    LoadTemplateOptionsByLocation = '[MMS Admin Override] Load Template Options By Location',
    LoadTemplateOptionsByLocationSuccess = '[Management API] Load Template Options By Location Success',
    LoadTemplateOptionsByLocationFailure = '[Management API] Load Template Options By Location Failure',
    LoadTemplateByLocation = '[MMS Admin Override] Load Template By Location',
    LoadTemplateByLocationSuccess = '[Management API] Load Template By Location Success',
    LoadTemplateByLocationFailure = '[Management API] Load Template By Location Failure',
    Select = '[MMS Admin Override Management] Select Location',
    SavedSelections = '[MMS Admin Override Management] Saved Selections',
    SavedSelectionsSuccess = '[MMS Admin Override Management] Saved Selections Success',
    SavedSelectionsFailure = '[MMS Admin Override Management] Saved Selections Failure',
}

export const MmsAdminActions = {
    loadAllLocation: createAction(MmsAdminAction.LoadAllLocation),
    loadAllLocationSuccess: createAction(
        MmsAdminAction.LoadAllLocationSuccess,
        props<{ locationSets: LocationSet[] }>()
    ),
    loadAllLocationFailure: createAction(MmsAdminAction.LoadAllLocationFailure, props<{ error: any }>()),
    loadTemplateOptionsByLocation: createAction(MmsAdminAction.LoadTemplateOptionsByLocation),
    loadTemplateOptionsByLocationSuccess: createAction(
        MmsAdminAction.LoadTemplateOptionsByLocationSuccess,
        props<{ template: any[] }>()
    ),
    loadTemplateOptionsByLocationFailure: createAction(MmsAdminAction.LoadTemplateOptionsByLocationFailure, props<{ error: any }>()),
    loadTemplateByLocation: createAction(MmsAdminAction.LoadTemplateByLocation),
    loadTemplateByLocationSuccess: createAction(
        MmsAdminAction.LoadTemplateByLocationSuccess,
        props<{ template: any[] }>()
    ),
    loadTemplateByLocationFailure: createAction(MmsAdminAction.LoadTemplateByLocationFailure, props<{ error: any }>()),
    select: createAction(MmsAdminAction.Select, props<{ selected: any }>()),
    savedSelections: createAction(MmsAdminAction.SavedSelections, props<{ selections: any, storeNumber: any, selectedEffectiveDate: any }>()),
    savedSelectionsSuccess: createAction(
        MmsAdminAction.SavedSelectionsSuccess,
        props<{ template: any }>()
    ),
    SavedSelectionsFailure: createAction(MmsAdminAction.SavedSelectionsFailure, props<{ error: any }>()),
};

export const AsyncActions = {
    loadActions: [
        MmsAdminActions.loadAllLocation,
        MmsAdminActions.loadTemplateOptionsByLocation,
    ],
    successActions: [
        MmsAdminActions.loadAllLocationSuccess,
        MmsAdminActions.loadTemplateOptionsByLocationSuccess,
    ],
    errorActions: [
        MmsAdminActions.loadAllLocationFailure,
        MmsAdminActions.loadTemplateOptionsByLocationFailure,
    ],
};
